// supports all modern browsers (not IE, minimal edge)
// if IE support is required then search for polyfills
// https://caniuse.com/#feat=getrandomvalues
// https://caniuse.com/#feat=typedarrays
// http://kangax.github.io/compat-table/es6/#test-Array.from

dmx.oauth2 = {

  sha256: function(ascii) {
    function rightRotate(value, amount) {
      return (value>>>amount) | (value<<(32 - amount));
    }

    var mathPow = Math.pow;
    var maxWord = mathPow(2, 32);
    var lengthProperty = 'length';
    var i, j; // Used as a counter across the whole file
    var result = '';

    var words = [];
    var asciiBitLength = ascii[lengthProperty]*8;

    var hash = dmx.oauth2.sha256.h = dmx.oauth2.sha256.h || [];
    var k = dmx.oauth2.sha256.k = dmx.oauth2.sha256.k || [];
    var primeCounter = k[lengthProperty];

    var isComposite = {};
    for (var candidate = 2; primeCounter < 64; candidate++) {
      if (!isComposite[candidate]) {
        for (i = 0; i < 313; i += candidate) {
          isComposite[i] = candidate;
        }
        hash[primeCounter] = (mathPow(candidate, 0.5)*maxWord)|0;
        k[primeCounter++] = (mathPow(candidate, 1/3)*maxWord)|0;
      }
    }

    ascii += '\x80'; // Append '1' bit (plus zero padding)
    while (ascii[lengthProperty]%64 - 56) ascii += '\x00'; // More zero padding
    for (i = 0; i < ascii[lengthProperty]; i++) {
      j = ascii.charCodeAt(i);
      if (j>>8) return; // ASCII check: only accept characters in range 0-255
      words[i>>2] |= j << ((3 - i)%4)*8;
    }
    words[words[lengthProperty]] = ((asciiBitLength/maxWord)|0);
    words[words[lengthProperty]] = (asciiBitLength);

    for (j = 0; j < words[lengthProperty];) {
      var w = words.slice(j, j += 16);
      var oldHash = hash;
      hash = hash.slice(0, 8);

      for (i = 0; i < 64; i++) {
        var i2 = i + j;
        var w15 = w[i - 15], w2 = w[i - 2];
        var a = hash[0], e = hash[4];
        var temp1 = hash[7] +
          (rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25)) + // S1
          ((e&hash[5])^((~e)&hash[6])) + // ch
          k[i] +
          (w[i] = (i < 16) ? w[i] : (
              w[i - 16] +
              (rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ (w15>>>3)) + // s0
              w[i - 7] +
              (rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ (w2>>>10)) // s1
            )|0
          );
        var temp2 = (rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22)) + // S0
          ((a&hash[1])^(a&hash[2])^(hash[1]&hash[2])); // maj

        hash = [(temp1 + temp2)|0].concat(hash);
        hash[4] = (hash[4] + temp1)|0;
      }

      for (i = 0; i < 8; i++) {
        hash[i] = (hash[i] + oldHash[i])|0;
      }
    }

    for (i = 0; i < 8; i++) {
      for (j = 3; j + 1; j--) {
        var b = (hash[i]>>(j*8))&255;
        result += ((b < 16) ? 0 : '') + b.toString(16);
      }
    }

    return result;
  },

  hex2bin: function(s) {
    var ret = [], i = 0, l;

    s += '';

    for (l = s.length; i < l; i += 2) {
      var c = parseInt(s.substr(i, 1), 16);
      var k = parseInt(s.substr(i + 1, 1), 16);
      if (isNaN(c) || isNaN(k)) return false;
      ret.push((c << 4) | k);
    }

    return String.fromCharCode.apply(String, ret);
  },

  dec2hex: function(dec) {
    return ('0' + dec.toString(16)).substr(-2);
  },

  dec2bin: function(arr) {
    return dmx.oauth2.hex2bin(Array.from(arr, dmx.oauth2.dec2hex).join(''));
  },

  sha256bin: function(ascii) {
    return dmx.oauth2.hex2bin(dmx.oauth2.sha256(ascii));
  },

  base64_urlencode: function(str) {
    return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  },

  random_string: function(len) {
    var arr = new Uint8Array(len);
    window.crypto.getRandomValues(arr);
    var str = dmx.oauth2.base64_urlencode(dmx.oauth2.dec2bin(arr));
    return str.substring(0, len);
  },

  generate_state: function() {
    return dmx.oauth2.random_string(16);
  },

  generate_auth_code: function() {
    return dmx.oauth2.random_string(48);
  },

  generate_code_verifier: function() {
    return dmx.oauth2.random_string(48);
  },

  generate_code_challenge: function(verifier) {
    return dmx.oauth2.base64_urlencode(dmx.oauth2.sha256bin(verifier));
  }

};
